<template>
  <div class="social-share" :class="parent">
    <p>Diese Seite teilen:</p>
    <ul>
      <li><a href="#" class="icon-fb" @click.prevent="shareOnFacebook" /></li>
      <li><a href="#" class="icon-twitter" @click.prevent="shareOnTwitter" /></li>
      <li><a href="#" class="icon-xing" @click.prevent="shareOnXing" /></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SocialShare",
  data() {
    return {
      url: ''
    }
  },
  props: {
    parent: {
      type: String,
      default: 'page'
    }
  },
  methods: {
    shareOnFacebook() {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.url, '_blank', 'width=600,height=400');
    },
    shareOnTwitter() {
      window.open('https://twitter.com/intent/tweet?text=' + this.url, '_blank', 'width=600,height=400');
    },
    shareOnXing() {
      window.open('https://www.xing.com/social/share/spi?url=' + this.url, '_blank', 'width=500,height=730');
    }
  },
  mounted() {
    this.url = encodeURI(window.location.href);
  }
}
</script>

<style scoped>
.social-share {
  display: flex;
  align-items: center;
}
ul {
  margin: 0 -7px 0 10px;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: flex-end;
}
a {
  font-family: "Icons", sans-serif;
  color: #A7A9AC;
  text-decoration: none;
  font-size: 36px;
  margin: 0 4px;
  transition: 0.2s ease;
}
a:hover {
  color: #102D61;
}
p {
  margin: 0;
}
.social-share.site {
  color: #102D61;
}
.social-share.site a {
  color: #102D61;
}
.social-share.site a:hover {
  color: #C7125C;
}
@media(min-width: 1000px) {
  .social-share.site {
    text-align: right;
    margin-top: 50px;
  }
  .social-share.site ul {
    justify-content: flex-end;
  }
  .social-share.site {
    display: block;
  }
}
</style>